import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import InputField from '@/components/forms/InputField'
import eyeOpenImg from '@/assets/buy-flow/eye-open.svg'
import eyeOffImg from '@/assets/buy-flow/eye-off.svg'

import styles from './PasswordInputField.module.scss'

const PasswordInputField = ({ hide = true, name = 'password', label = 'Password', ...rest }) => {
  const [isHidden, updateIsHidden] = useState(hide)

  const handleInputClick = () => {
    updateIsHidden(!isHidden)
  }

  // The toggle rides inside nui's `.nui-input-wrapper` (position: relative,
  // sized to the input alone) as the Input's `rightElement`, so it is centred
  // on the 40px input whether or not the label above it is rendered. It also
  // switches on nui's right-padding modifier, so typed text stops short of it.
  const toggle = (
    <div className={styles.toggleHolder} onClick={handleInputClick} role="presentation">
      <Image alt="hide password" className={`${styles.eye} ${!isHidden && styles.hide}`} src={eyeOpenImg} />
      <Image alt="show password" className={`${styles.eye} ${isHidden && styles.hide}`} src={eyeOffImg} />
    </div>
  )

  return (
    <InputField
      data-testid="password-input-field"
      label={label}
      labelProps={{ hidden: true }}
      name={name}
      rightElement={toggle}
      size="large"
      type={isHidden ? 'password' : 'text'}
      {...rest}
    />
  )
}

export default PasswordInputField

PasswordInputField.propTypes = {
  hide: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
}
